<template>
  <fragment>
    <Transition name="expand">
    <tr :key="'secondary_header_'+ unitIndex" v-show="show && unitIndex == 0" style="border-top: 12px solid #fff">
      <th colspan="2" class="border-0"></th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark')" style="min-width: 150px;max-width: 150px;">Description</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-nowrap'" style="min-width: 150px; max-width: 150px;">Lot #</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Quantity</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Stackable</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Length</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Width</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Height</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Weight</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center'">Hazard</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-left'">Contents</th>
      <th :class="(unit.expanded ? 'header-active' : 'header-dark') + ' text-center squeeze'"></th>
    </tr>
    </Transition>

    <Transition name="expand">
    <tr class="bg-gray" :key="'secondary_unit_'+ unitIndex" v-show="show">
        <td colspan="2" class="bg-white border-0"></td>

        <td>
          <input :disabled="readOnly" class='sparse-text' type='text' v-model="unit.description" :id="'r'+rowIndex+'secondaryDesc'+unitIndex"
            autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
            placeholder="description..."
            v-validate="'required'"
            v-on:keyup="productLiveSearch"
          />
          <div :id="'r'+rowIndex+'secondaryDesc'+unitIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="productrows && productrows.length > 0">
            <template v-for="(product, pIdx) in productrows">
              <div :key="pIdx" class="customLiveSearchElement" v-on:click="productSelected(unit, product)">{{ product.description }}</div>
            </template>
          </div>
        </td>

        <td>
          <input class='sparse-text' type='text' v-model="unit.lot" :id="'r'+rowIndex+'secondaryLot'+unitIndex"
            autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
            placeholder="lot number..."
            v-on:keyup="lotLiveSearch($event, unit)"
            v-on:click="showLots($event, unit)"
            :disabled="readOnly"
          />
          <div :id="'r'+rowIndex+'secondaryLot'+unitIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="lotRows.length > 0">
            <template v-for="(lot, lIdx) in lotRows">
              <div :key="lIdx" class="customLiveSearchElement" v-on:click="lotSelected(unit, lot)">{{ lot.name + ' (' + lot.available + ')' }}</div>
            </template>
          </div>
        </td>


        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="unit.quantity" /></td>
        <td class="text-center align-middle" :title="unit.type + ': ' + unit.apiIntegration + ' -- ' + unit.internalId">                        
          <select :disabled="readOnly" class="form-control form-control-sm sparse-text" v-model="unit.stackable">
            {{ unit.stackable }}
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
        </td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="unit.length" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="unit.width" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="unit.height" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' type='text' v-model="unit.weight" /></td>
        <td class="text-center align-middle">                        
          <select :disabled="readOnly" class="form-control form-control-sm sparse-text expander" v-model="unit.hazardous">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
        </td>
        <td>
          <button type="button"
          :class="'btn btn-sm btn-block text-left text-nowrap ' + (unit.expanded ? 'btn-primary' : 'btn-secondary')"
          :disabled="unit.type == 'None'"
          v-on:click="onUnitsExpand">
              <span class="d-block">
                  {{numPrimaryUnits || '---'}}
                  <span class="float-right" v-if="unit.type != 'None'"><i :class="unit.expanded ? 'fa fa-chevron-up spinEffect' : 'fa fa-chevron-down spinEffectReverse'"></i></span>
              </span>
          </button>
        </td>
        <td class="align-middle text-nowrap">
            <a v-if="!readOnly" class="text-body" v-on:click="cloneUnit"><i class="fa fa-fw fa-copy"></i></a>
            <a v-if="!readOnly" class="text-danger" v-on:click="removeUnit"><i class="fa fa-fw fa-times" ></i></a>
        </td>
    </tr>
    </Transition>


    <!-- NEST PRIMARY-->
    <Transition name="expand">
    <tr v-show="show && unit.expanded" transition="expand">
        <th colspan="2"></th>
        <th class="header-dark inset-primary-left-header">{{unit.description}}</th>
        <th class="header-dark text-nowrap">Lot #</th>
        <th class="header-dark text-center">Quantity</th>
        <th class="header-dark text-center">Stackable</th>
        <th class="header-dark text-center">Length</th>
        <th class="header-dark text-center">Width</th>
        <th class="header-dark text-center">Height</th>
        <th class="header-dark text-center">Weight</th>
        <th class="header-dark text-center">Hazard</th>
        <th class="header-dark text-left">Contents</th>
        <th class="header-dark text-center squeeze"></th>
    </tr>
    </Transition>

    <tr v-show="show && unit.expanded" v-for="(primary,primaryIndex) in this.unit.components" :key="'primary_'+primaryIndex">
        <td colspan="2"></td>

        <td class="inset-primary-left-body">

          <input :disabled="readOnly" class='sparse-text' type='text' v-model="primary.description" placeholder="description..."
            :id="'r'+rowIndex+'secondaryDesc'+unitIndex+'-'+primaryIndex"
            autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
            v-on:keyup="productLiveSearch" />
          <div :id="'r'+rowIndex+'secondaryDesc'+unitIndex+'-'+primaryIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="productrows && productrows.length">
            <template v-for="(product, pIdx) in productrows">
              <div :key="pIdx" class="customLiveSearchElement" v-on:click="productSelected(primary, product)">{{ product.description }}</div>
            </template>
          </div>

        </td>
        <td>

          <input class='sparse-text' type='text' v-model="primary.lot" placeholder="lot number..."
            :id="'r'+rowIndex+'secondaryLot'+unitIndex+'-'+primaryIndex"
            autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
            v-on:keyup="lotLiveSearch($event, primary)"
            v-on:click="showLots($event, primary)"
            :disabled="readOnly"
          />
          <div :id="'r'+rowIndex+'secondaryLot'+unitIndex+'-'+primaryIndex+'auto'" class="customLiveSearch" style="max-width: 240px;" v-show="lotRows.length > 0">
            <template v-for="(lot, lIdx) in lotRows">
              <div :key="lIdx" class="customLiveSearchElement" v-on:click="lotSelected(primary, lot)">{{ lot.name + ' (' + lot.available + ')' }}</div>
            </template>
          </div>

        </td>

        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' style="width: 40px" type='text' v-model="primary.quantity" /></td>
        <td class="text-center align-middle">                        
          <select :disabled="readOnly" class="form-control form-control-sm sparse-text expander" style="min-width: 68px" v-model="primary.stackable">
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' style="width: 40px" type='text' v-model="primary.length" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' style="width: 40px" type='text' v-model="primary.width" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' style="width: 40px" type='text' v-model="primary.height" /></td>
        <td class="text-center align-middle"><input :disabled="readOnly" class='sparse-text expander' style="width: 40px" type='text' v-model="primary.weight" /></td>
        <td class="text-center align-middle">                        
          <select :disabled="readOnly" class="form-control form-control-sm sparse-text expander" style="min-width: 68px" v-model="primary.hazardous">
            <option>Yes</option>
            <option selected="selected">No</option>
          </select>
        </td>

        <td class="text-left align-left text-nowrap">
          <button type="button" class="btn btn-sm text-left text-nowrap btn-secondary" style="width: 100%" disabled>
              <span class="d-block">
                  {{(primary.quantity*(primary.unitsPerCase || 1)) || '---'}}
              </span>
          </button>
        </td>
        <td class="align-middle text-nowrap">
          <a v-if="!readOnly" class="text-body" v-on:click="duplicatePrimary(primary, primaryIndex)"><i class="fa fa-fw fa-copy"></i></a>
          <a v-if="!readOnly" class="text-danger" v-on:click="removePrimary(primaryIndex)"><i class="fa fa-fw fa-times" ></i></a>
        </td>
    </tr>

    <tr v-show="show && unit.expanded && !readOnly">
        <td colspan="2" class="bg-white border-0"></td>    
        <td colspan="11" class="text-right inset-primary-left-body" style="border-bottom: 12px solid rgba(248,248,248,1)">
          <button class="btn btn-clear" v-on:click="addPrimaryUnit"><i class="fa fa-plus-circle"></i> ADD ROW</button>
        </td>
    </tr>
    <!-- END NEST PRIMARY -->


  </fragment>
</template>

<script>

import { filterInventoryList, getLotNumbers } from '../../utils/autocompleteProducts';
import { DIVA_COMPANY_ID } from "../../constants/entities";

var productrows = [];
var lotRows = [];

const defaultUnit = () => ({
  internalId: "",
  description: "",
  quantity: 1,
  length: 1,
  width: 1,
  height: 1,
  dimensionunit: 4,
  weight: 1,
  weightunit: 2,
  lot: '',
  unitsPerCase: 1,
  components: [],
  includeInTransferOrder: false,
  stackable: true,
  hazardous: false,
  expanded: true,
});

const formatTextFields = function() {
  document.querySelectorAll('.expander').forEach(function( input ) {
    const extraSpace = input.type == 'text' ? 2 : 5;
    input.style.width=(input.value.length+extraSpace)+'ch';
    input.oninput= function() {
      input.style.width=(input.value.length+extraSpace)+'ch';
    }
  });
};

export default {
  name: 'ShippingLvls',
  props: ['unit', 'unitIndex', 'show', 'customerCompanyEntity', 'rowIndex', 'readOnly'],
  
  data: function () {
    return {
      productrows,
      lotRows,
    }
  },
  mounted () {
    console.log(this.rowIndex + "---------------------------===== " + this.customerCompanyEntity + " " + this.unit.includeInTransferOrder);
    console.log("-"+this.unit.stackable+"-");
    // if (!this.unit.hazardous) this.unit.hazardous = false;
    // if (!this.unit.stackable) this.unit.stackable = true;
    this.$nextTick(formatTextFields);
  },
  computed: {
    numPrimaryUnits: function() {
      let total = 0;
      for (var i = 0; i < this.unit.components.length; i++) {
        total += this.unit.components[i].quantity * this.unit.quantity;
      }
      return total || (this.unit.quantity*this.unit.unitsPerCase);
    }
  },
  methods: {

    productLiveSearch: async function (event) {
      console.log(this.customerCompanyEntity + " product search " + event.target.id + " " + event.target.value);
      const text = event.target.value;
      if (text.length < 1) {
        this.dissmissAutoCompletes();
      } else {
        this.productrows = await filterInventoryList(text);
        if (this.productrows.length) {
          this.showAutoComplete(event.target.id+'auto');
        }
      }
    },

    productSelected: async function (unit, product) {
      console.log('productSelected');
      this.dissmissAutoCompletes();
      const [lengthUnits, weightUnits] = this.$parent.$parent.$parent.shippingDimensionUnits.split('/');
      if(product) {
          unit.internalId = product.internalId;
          unit.description = product.description;
          unit.dimensionunit = lengthUnits == "in" ? 4 : 1;
          unit.height = product.dimensions.height;
          unit.length = product.dimensions.length;
          unit.quantity = unit.quantity || 1;
          unit.weight = product.dimensions.weight;
          unit.weightunit = weightUnits == "kgs" ? 1 : 2;
          unit.width = product.dimensions.width;
          unit.type = product.type;
          unit.unitsPerCase = product.unitsPerCase;
          unit.apiIntegration = product.apiIntegration;
          unit.expanded = false;
          unit.hazardous = false;
          unit.stackable = true;
          
          // Repopulate lot options
          this.lotRows = getLotNumbers(product.internalId, unit.quantity);
          unit.lot = "";
      }
    },

    showLots: async function(event, u) {
      console.log("showLots");
      event.stopPropagation();
      event.preventDefault();
      this.lotRows = await getLotNumbers(u.internalId, u.quantity);
      if (this.lotRows.length > 0) {
        await this.$nextTick(this.showAutoComplete(event.target.id+'auto')); 
        this.showAutoComplete(event.target.id+'auto');
      }
    },

    lotLiveSearch: async function (event, u) {
      console.log("lotLiveSearch " + event.target.id + " " + event.target.value + " " + u.internalId);
      const text = event.target.value;

      // only filter when text is valid and for DIVA customers
      if (text.length > 0 && this.customerCompanyEntity == DIVA_COMPANY_ID) {

        // filter from full list
        const fullLotList = await getLotNumbers(u.internalId, u.quantity);
        if (fullLotList) {
          this.lotRows = fullLotList.filter(lot => lot.name.includes(text));
        }
        this.showAutoComplete(event.target.id+'auto');
      }
    },
    lotSelected: function (u, lot) {
      console.log('lotSelected ' + JSON.stringify(lot));
      this.dissmissAutoCompletes();
      if (lot) {
        u.lot = lot.name;
        u.available = lot.available;
      }
    },

    dissmissAutoCompletes: function() {
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      console.log("showAutocomplete " + id);
      document.getElementById(id).style.display = 'block';
    },

    addPrimaryUnit() {
      if(!Array.isArray(this.unit.components)) this.unit.components = [];
      this.unit.components.push(defaultUnit());
    },

    cloneUnit() {
      this.$emit('cloneUnit');
    },
    removeUnit() {
      this.unit.expanded = false;
      this.$emit('removeUnit');
    },

    duplicatePrimary: function (primary, index) {
      const primaryCopy = {
        ...primary,
      };
      this.unit.components.splice(index + 1, 0, primaryCopy)
    },

    removePrimary: function (index) {
      console.log('remove primary ' + index);
      if (this.unit.components.length > 0) {
        this.unit.components.splice(index,1);
      }
    },

    onUnitsExpand() {
      console.log("expand to primary! " + this.unit.expanded);
      this.unit.expanded = !this.unit.expanded;
      // this.$nextTick(formatTextFields);
      this.$forceUpdate();
    }
  }
}
</script>

<style>

  
  .expand-enter-active {
    opacity: 0.2;
    transition: all 0.5s ease;
  }
  .expand-leave-active {
    transition: all 0.5s ease;
  }
  .expand-enter-from {
  }
  .expand-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }
  
  .bounce-enter-active {
    animation: bounce-in 0.5s ease;
  }
  .bounce-leave-active {
    animation: bounce-in 0.5s ease reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }


  .td-inset {
    background: #00000000 !important;
    background-color: #00000000 !important;
    padding-left: 25px !important; 
  }

</style>


// WEBPACK FOOTER //
// SecondaryRow.vue?3267dace